import { Button, Chip, CircularProgress } from '@material-ui/core';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { MeetingDetailsContext } from '../../../services/meeting-details/meeting-details.context';
import { useMeetingDetailsStyle } from './meeting-details.style';

export const MeetingStatus = () => {
  const classes = useMeetingDetailsStyle();
  const history = useHistory();

  const { states, functions } = useContext(MeetingDetailsContext);
  const { meeting, status, isInThePast, loading } = states;
  const { chooseMeetingStatus, requestToJoin } = functions;

  const MeetingStatus = () => {
    switch (status) {
      case 0:
        if (!isInThePast) {
          return (
            <Button
              variant='contained'
              size='small'
              id='edit-meeting'
              color='secondary'
              onClick={() =>
                history.push({
                  pathname: `/updatemeeting/${parseInt(meeting.id)}`,
                  state: meeting,
                })
              }
            >
              Edit Meeting
            </Button>
          );
        } else {
          return <Chip label='you were host' size='small' />;
        }
      case 1:
        if (!isInThePast) {
          return (
            <Chip
              color='secondary'
              label='you have joined this meeting'
              size='small'
            />
          );
        } else {
          return <Chip className={classes.guest} label='you were invited' size='small' />;
        }
      case 2:
        if (!isInThePast) {
          return (
            <Chip
              color='primary'
              label='you have rejected this meeting'
              size='small'
            />
          );
        } else {
          return <Chip className={classes.guest} label='you were invited' size='small' />;
        }
      case 3:
        if (!isInThePast) {
          return (
            <div className={classes.submitBox}>
              <div mt={4} className={classes.wrapper}>
                <Button
                  className={classes.acceptBtn}
                  variant='contained'
                  size='small'
                  onClick={() => chooseMeetingStatus(1, 'accept')}
                  color='secondary'
                  disabled={loading}
                >
                  Accept
                </Button>
                <Button
                  variant='contained'
                  size='small'
                  onClick={() => chooseMeetingStatus(2, 'reject')}
                  color='primary'
                  disabled={loading}
                >
                  Reject
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          );
        } else {
          return <Chip className={classes.guest} label='you were invited' size='small' />;
        }
      case 4:
        return <Chip color='primary' label='Requested' size='small' />;
      case 5:
        return (
          <Chip
            color='secondary'
            label='The host has accepted the join request'
            size='small'
          />
        );
      case 6:
        return (
          <Chip
            color='primary'
            label='The host has declined the join request'
            size='small'
          />
        );
      case 7:
        return (
          <div className={classes.submitBox}>
            <div className={classes.wrapper}>
              <Button
                variant='outlined'
                size='small'
                onClick={requestToJoin}
                style={{padding: '0px 10px'}}
                color='secondary'
                disabled={loading}
              >
                Request to join this meeting
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return <MeetingStatus />;
};
